import { Markierung } from '@/domain/mitarbeiter/features/rotationsplan/entities/Markierung';

export class Arbeitsbereich {
  constructor({ markierung, name }: { markierung: Markierung; name: string }) {
    this.markierung = markierung;
    this.name = name;
  }

  markierung: Markierung;
  name: string;
}
